export enum DashboardTimeframes {
    today = 1,
    week = 2,
    month = 3,
    custom = 4
}
